import React from "react";

const Chapter7 = () => {
  return (
    <>
      <h2>
        What's in Denver Metro Surface Water that is a Contaminant of Emerging
        Concern?
      </h2>
      <p>
        Advances in analytical methods have improved measuring chemical
        concentrations at lower levels than was previously possible. Both USGS
        and EPA have monitored for Contaminants of Emerging Concern in the
        Denver Metro area since the 1990s. The Water Quality Assessment Tool
        website provides simplified public access to the data.
      </p>
      <p>
        In 2009, EPA Region 8 began sampling surface waters in the Northern
        Front Range to develop and improve analytical capability to analyze
        CECs. The set of 14 CECs presented here include the more commonly
        detected chemicals and some of special concern.
      </p>
    </>
  );
};

export default Chapter7;
